module.exports = __webpack_public_path__ + "img/24.0dda5e53.jpg";